import styled from 'styled-components';

export const DivFather = styled.div`
  width: 100%;
  margin-top: 24px;
  background: #FAFAFB;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

export const ToolBarContainer = styled.div`
  display: flex;
  justify-content: space-around;
  margin-bottom: 24px;
`;

export const ButtonAddContainer = styled.div`
  display: flex;
  align-items: center;
  margin-right: 15px;
`;
